import { render, staticRenderFns } from "./reward.vue?vue&type=template&id=06a83851&scoped=true"
import script from "./reward.vue?vue&type=script&lang=js"
export * from "./reward.vue?vue&type=script&lang=js"
import style0 from "./reward.vue?vue&type=style&index=0&id=06a83851&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a83851",
  null
  
)

export default component.exports